import { render, staticRenderFns } from "./FlatfileButton.vue?vue&type=template&id=34c8a7df&"
import script from "./FlatfileButton.vue?vue&type=script&lang=js&"
export * from "./FlatfileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports